import { LIST_NOTIFICATION, NOTIFICATION_COUNT, NOTIFICATION_COUNT_DETAILS, NOTIFICATION_PREFERENCE, NOTIFICATION_PREFERENCE_GET, READ_ALL_NOTIFICATION, READ_NOTIFICATION } from "../api"
import axiosInstance from "../axiosInstance"

export const notificationList = (props) => onResponse => {
    try {
        let BASE_URL = LIST_NOTIFICATION + '?'
        if (props?.page) {
            BASE_URL += 'page=' + props.page + '&'
        }
        if (props?.limit) {
            BASE_URL += 'limit=' + props.limit + '&'
        }
        if (props?.search) {
            BASE_URL += 'search=' + props.search + '&'
        }
        if (props?.order) {
            BASE_URL += 'order=' + props.order + '&'
        }
        if (props?.museum_id) {
            BASE_URL += 'museum_id=' + props.museum_id + '&'
        }
        if (props?.start_date) {
            BASE_URL += 'start_date=' + props.start_date + '&'
        }
        if (props?.end_date) {
            BASE_URL += 'end_date=' + props.end_date + '&'
        }
        if (props?.mentions) {
            BASE_URL += 'mentions=' + props.mentions + '&'
        }

        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err?.response?.data);
            });
    } catch (error) {

    }
}


export const notificationcount = (props) => onResponse => {
    console.log(props,"not");
    
    try {
        let BASE_URL = NOTIFICATION_COUNT + '?'
        if (props?.page) {
            BASE_URL += 'page=' + props.page + '&'
        }
        if (props?.is_readed) {
            BASE_URL += 'is_readed=' + props.is_readed + '&'
        }
        if (props?.museum_id) {
            BASE_URL += 'museum_id=' + props.museum_id + '&'
        } 
        if (props?.is_mention) {
            BASE_URL += 'is_mention=' + props.is_mention + '&'
        }

        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err?.response?.data);
            });
    } catch (error) {

    }
}


export const notificationAllread = (props) => (onResponse) => {
    try {

        axiosInstance.post(READ_ALL_NOTIFICATION, props)
            .then((response) => {
                onResponse(response.data)
            })
            .catch((err) => {
                console.log(err);
                onResponse(err?.response?.data)
            });
    } catch (error) { }
}


export const readnotification = (props) => (onResponse) => {
    try {
        axiosInstance.put(READ_NOTIFICATION, props)
            .then((response) => {
                onResponse(response.data)
            }).catch((err) => {
                console.log(err);
                onResponse(err?.response?.data)
            });

    } catch (error) { }
}


export const notificationPrefer = (props) => (onResponse) => {
    try {
        axiosInstance.post(NOTIFICATION_PREFERENCE, props)
            .then((response) => {
                onResponse(response.data)
            }).catch((err) => {
                console.log(err?.response?.data);
            })

    } catch (error) { }
}


export const getnotificationPrefer = (props) => (onResponse) => {
    try {
        axiosInstance.get(NOTIFICATION_PREFERENCE_GET, props?.page)
            .then((response) => {
                onResponse(response.data)
            }).catch((err) => {
            })

    } catch (error) { }
}

export const getNotificationDetails = (props) => (onResponse) => {
    try {
        let BASE_URL = NOTIFICATION_COUNT_DETAILS + '?'
        if (props?.page) {
            BASE_URL += 'page=' + props.page + '&'
        }
        if (props?.limit) {
            BASE_URL += 'limit=' + props.limit + '&'
        }
        if (props?.sender_id) {
            BASE_URL += 'sender_id=' + props.sender_id + '&'
        }
        if (props?.museum_id) {
            BASE_URL += 'museum_id=' + props.museum_id + '&'
        }
        if (props?.order) {
            BASE_URL += 'order=' + props.order + '&'
        }
        if (props?.date) {
            BASE_URL += 'date=' + props.date + '&'
        }
        if (props?.notification_id) {
            BASE_URL += 'notification_id=' + props.notification_id + '&'
        }
        if (props?.is_mention) {
            BASE_URL += 'is_mention=' + props.is_mention + '&'
        }

        axiosInstance.get(BASE_URL)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err?.response?.data);
            });
    } catch (error) {

    }



}